import React from 'react'

export default function Footer() {
  const handleMail=()=>{
           const email="bikashthakur8387@gmail.com"; 
               const isMobile=/iPhone|iPad|Android/i.test(navigator.userAgent);
if(isMobile){
  window.location.href=`mailto:${email}`;

}else{
  window.open(`https://mail.google.com/mail/?view=cm&to=${email}`,"_blank");

}

  }
  return (
    <>
    <section className=' bg-[rgb(240_240_253_/_98%)] h-fit py-4'>
        <div className="text-center flex flex-col border-b-2 border-black pt-2">
          <h1 className='text-2xl md:text-4xl font-semibold md:font-bold inline-block bg-gradient-to-r from-black to-yellow-400 via-red-500 bg-clip-text text-transparent'>D.B</h1>
          <h2 className='text-2xl md:text-4xl font-semibold md:font-bold inline-block bg-gradient-to-r from-black to-yellow-400 via-red-500 bg-clip-text text-transparent mb-4'>Digital Marketing With Bikash</h2>

        </div>

        <div className="bottom div flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="20vh" viewBox="0 -960 960 960" width="20vw" fill="#1a0675"><path d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z"/></svg>
<h3 className='text-red-500 text-2xl md:text-3xl font-semibold md:font-bold'>Promote Your Business Though Us</h3>
        </div>
        <h1 className='text-center text-2xl md:text-4xl font-semibold md:font-bold '>Contact us</h1>
        <div className="contact flex justify-evenly py-6">
        <div className="flex w-[80%] justify-evenly text-2xl md:text-3xl font-semibold md:font-bold 
">
        <a href="https://www.facebook.com/bikash.thakur.584632" target='_blank'  className='inline-block bg-gradient-to-r from-blue-700 to-blue-500 bg-clip-text text-transparent'>
                  <i className="fa-brands fa-facebook"></i>

        </a>
        <a href= "https://wa.me/9779746672410"target='_blank'
         className='inline-block bg-gradient-to-r from-green-500 to-green-400 bg-clip-text text-transparent'> 
                   <i className="fa-brands fa-square-whatsapp"></i>
</a>
<a href="https://www.instagram.com/bikashthakur8387/" target='_blank' className='inline-block bg-gradient-to-r from-red-500 to-pink-400 bg-clip-text text-transparent'>       
   <i className="fa-brands fa-square-instagram"></i>
</a>        
<a href="https://www.tiktok.com/@bikashthakur53"target='_blank'className=''>
    <i className="fa-brands fa-tiktok"></i>

</a>

        </div>
        <button type="button" className=' text-white bg-red-700 
        p-1 md:p-2 rounded-2xl'onClick={handleMail}>Email us</button>
        </div>
        <div className='flex w-full justify-evenly py-2 flex-col md:flex-row  items-center'>
         <div>
            
         <i className="fa-solid fa-phone fa-shake  m-1"></i>    
          <span>9746672410</span>

         </div>
          <div>
            <i className="fa-solid fa-envelope m-1"></i>
<span>bikashthakur8387@gmail.com</span>
  </div>
      <div> 
  <i className="fa-solid fa-location-dot m-1"></i>
  <span>       janakpurdham-7 </span>


</div>
        </div>
        <div className='developer text-center pb-6'>
          < h2 className='text-xl md:text-2xl'>Website Developed by</h2>
          <a href="https://www.facebook.com/prem.shah.272930 " target="_blank" className=' inline-block font-semibold md:font-bold text-2xl md:text-3xl 
          bg-gradient-to-r from-black to-red-700 bg-clip-text text-transparent border-b-2
           border-blue-500 cursor-pointer' > Prem Kumar Sah </a>          
        </div>
    </section>
    </>
      
  )
}
